import { withTheme } from 'styled-components'
import Modal from './Modal'

export default withTheme(Modal)
